/**
 * Glow Price admin brand design tokens.
 *
 * Centralized palette for the admin console. Pages and components should
 * read from antd's ConfigProvider rather than these constants directly so
 * the theme can be re-themed in a single place.
 *
 * Palette echoes the CDF (中免) red used across the H5 / 小程序 surfaces:
 * a confident 中免红 primary on a clean light-grey shell with a dark,
 * professional sider.
 */
export const GLOW_TOKENS = {
  colors: {
    primary: "#C8102E",
    primaryHover: "#E02844",
    bgLayout: "#F4F4F5",
    bgContainer: "#FFFFFF",
    border: "#EEEEEE",
    textPrimary: "#1A1A1A",
    textSecondary: "#666666",
    textMuted: "#999999",
    success: "#2E9B5B",
    warning: "#FF8F1F",
    error: "#C8102E",
    /** Gold accent — reserve for 会员 / 精选 small surfaces only. */
    gold: "#C9A227",
    siderBg: "#1F1A1B",
    siderHoverBg: "#2F2628",
    siderText: "#F5F5F5",
    siderTextMuted: "rgba(245,245,245,0.55)",
    tableHeaderBg: "#FAFAFA",
    tableRowHoverBg: "#FCF2F3",
  },
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'PingFang SC', 'Microsoft YaHei', 'Hiragino Sans GB', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  borderRadius: 8,
  borderRadiusLG: 12,
  controlHeight: 36,
  boxShadow:
    "0 1px 2px rgba(26,26,26,0.04), 0 2px 8px rgba(26,26,26,0.05)",
  boxShadowSecondary: "0 8px 24px rgba(26,26,26,0.08)",
} as const;

export type GlowTokens = typeof GLOW_TOKENS;
